/**
 * Alphabetische Sortierung für Navigations- und Auswahllisten (Projektregel, siehe CLAUDE.md):
 * Listeneinträge in Navigationen und innerhalb ihrer Bereiche stehen immer alphabetisch.
 * Sortiert nach der ANGEZEIGTEN (ggf. übersetzten) Beschriftung, deutsch-korrekt
 * (Umlaute wie Grundbuchstaben, Groß-/Kleinschreibung egal, Zahlen numerisch).
 */
export function nachAlphabet(liste, beschriftung = (x) => x?.label ?? x, sprache = 'de') {
  const collator = new Intl.Collator(sprache || 'de', { sensitivity: 'base', numeric: true });
  return [...(liste || [])].sort((a, b) => collator.compare(String(beschriftung(a) ?? ''), String(beschriftung(b) ?? '')));
}
